var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"name-style"},on),[_c('a',{on:{"click":_vm.onClick}},[_vm._v("\n        "+_vm._s(_vm.insertionOrderName)+"\n      ")])])]}}])},[_c('span',[_vm._v("\n    "+_vm._s(_vm.insertionOrderName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }